import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {baseStyles, BORDER_RADIUS, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import Space from "../commons/Space";
import TextField from "@material-ui/core/TextField";
import {Button, Chip} from "@material-ui/core";
import TextView from "../commons/TextView";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";

const useStyles = () => ({
  viewVouchersListField: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  viewVouchersListError: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    border: '1px solid red'
  },
});

class ManageActivityVoucher extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    const vouchers = [];
    const availableVouchers = [];
    const redeemedVouchers = [];
    if (activityData.vouchers) {
      activityData.vouchers.forEach((voucher) => {
        const voucherC = {
          id: voucher.id,
          code: voucher.pin ? voucher.code +' [PIN: '+ voucher.pin +']' : voucher.code,
          quantity: voucher.quantity,
          quantityGenerated: voucher.quantityGenerated,
        }
        vouchers.push(voucherC);
        if (voucherC.id && voucherC.quantity <= voucherC.quantityGenerated) {
          redeemedVouchers.push(voucherC);
        } else {
          availableVouchers.push(voucherC);
        }
      });
    }

    this.state = {
      vouchers: vouchers,
      availableVouchers: availableVouchers,
      redeemedVouchers: redeemedVouchers,
      deleteVoucherIds: activityData.deleteVoucherIds || [],
      newVoucher: null,
      showValidationMsg: false,
    };

  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  highlightErrors = () => {
    this.getData();
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError) {
    const {
      vouchers,
      deleteVoucherIds,
    } = this.state;

    if (!excludeError) {
      if (!vouchers || vouchers.length === 0) {
        this.updateState({showValidationMsg: true});
        return false;
      }
    }
    return {
      vouchers,
      deleteVoucherIds,
    };
  }

  render() {
    const {
      vouchers,
      availableVouchers,
      redeemedVouchers,
      newVoucher,
      showValidationMsg
    } = this.state;
    const {app, classes, isXS} = this.props;

    const isNewVoucherIncorrect = !newVoucher || newVoucher.trim().length === 0;
    const voucherError = showValidationMsg && vouchers.length === 0;
    return (
      <div className={classes.viewColumnFullWidthNoCenter}>
        {/*<div className={classes.flexColumnNoCenter}>*/}
        {/*  <div className={classes.expandCollapseBar}>*/}
        {/*    <div className={classes.buttonBaseAppDisabled} style={{minHeight: 48}}>*/}
        {/*      <div className={classes.flexRow}>*/}
        {/*        <Space vertical={16} />*/}
        {/*        <div className={classes.viewColumnFullWidthNoCenter}>*/}
        {/*          <div className={classes.flexRow} style={{minHeight: 48}}>*/}
        {/*            <InputLabel required error={voucherError} style={{fontWeight: 'bold', color: voucherError ? ColorNegative : ColorTheme}}>{<FormattedMessage id={'activity.manage.vouchersCodes'} />}</InputLabel>*/}
        {/*          </div>*/}
        {/*          <Typography color={'textSecondary'} variant={'caption'} align={'left'} className={classes.typoNormal} style={{marginTop: -12, marginBottom: 8}}>*/}
        {/*            <FormattedMessage id={'activity.manage.hintEnterVoucherCode'} />*/}
        {/*          </Typography>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}

        <SectionHeaderView labelId={'activity.manage.vouchersCodes'} subLabelId={'activity.manage.hintEnterVoucherCode'} />
        <div className={classes.formActivityWide}>
          <div className={classes.flexRowNoCenter}>
            <div className={classes.flexColumn}>
              <TextField
                variant="filled"
                required={!vouchers || vouchers.length === 0}
                fullWidth
                multiline
                rows={1}
                rowsMax={8}
                size="small"
                type="text"
                id="newVoucher"
                name="newVoucher"
                label={<FormattedMessage id={'activity.manage.enterVoucherCode'} />}
                InputProps={{disableUnderline: true}}
                inputProps={{maxLength: 100}}
                value={newVoucher}
                onChange={this.onChange}
                error={voucherError}
                helperText={voucherError ? <FormattedMessage id={'activity.manage.atleastOneVocuherNeeded'} /> : null}
              />
            </div>
            <Space vertical={12}/>
            <div className={classes.viewColumn}>
              <Button
                disableElevation
                size={isXS ? 'medium' : 'large'}
                disabled={isNewVoucherIncorrect}
                variant={'outlined'}
                color="primary"
                className={classes.buttonCamelCase}
                onClick={this.onAddNewVoucherClicked}>
                {<FormattedMessage id={'activity.manage.addCode'}/>}
              </Button>
            </div>
          </div>
        </div>
        <Space horizontal={8}/>

        <div className={classes.viewColumn}>
          {availableVouchers && availableVouchers.length > 0 ?
            <div className={classes.viewFullWidthWrap} style={{margin: -4, marginLeft: 0, marginRight: -8, paddingLeft: 2, paddingRight: 2, paddingBottom: 4}}>
              {availableVouchers.map((voucher, index) => {
                let chipName = voucher.code;
                return (
                  <Chip
                    size={'medium'}
                    key={voucher.id}
                    style={{minHeight: 32, marginTop: 4, marginBottom: 4, marginRight: app.isLTR ? 8 : 0, marginLeft: !app.isLTR ? 8 : 0, overflow: 'hidden', borderRadius: BORDER_RADIUS}}
                    label={<TextView numberOfLines={1} variant={'body1'} style={{minHeight: 32, whiteSpace: 'normal', paddingTop: 6, paddingBottom: 6}}>{chipName}</TextView>}
                    onDelete={this.onDeleteAvailableVoucher.bind(this, voucher, index)}
                  />
                );
              })}
            </div>
            : null
          }
        </div>

        {redeemedVouchers && redeemedVouchers.length > 0 ?
          <div className={classes.viewColumn}>
            <FieldSpace multiplier={3}/>
            <SectionHeaderView labelId={'activity.manage.redeemedVouchersList'} subLabelId={'activity.manage.hintRedeemedVoucherCodes'} />
            <div className={classes.viewFullWidthWrap} style={{margin: -4, marginLeft: 0, marginRight: -8, paddingLeft: 2, paddingRight: 2, paddingBottom: 4}}>
              {redeemedVouchers.map((voucher, index) => {
                let chipName = voucher.code;
                return (
                  <Chip
                    size={'medium'}
                    key={voucher.id}
                    style={{minHeight: 32, marginTop: 4, marginBottom: 4, marginRight: app.isLTR ? 8 : 0, marginLeft: !app.isLTR ? 8 : 0, overflow: 'hidden', borderRadius: BORDER_RADIUS}}
                    label={<TextView numberOfLines={1} variant={'body1'} style={{minHeight: 32, whiteSpace: 'normal', paddingTop: 6, paddingBottom: 6}}>{chipName}</TextView>}
                    onDelete={this.onDeleteRedeemVoucher.bind(this, voucher, index)}
                  />
                );
              })}
            </div>
          </div>
          : null
        }
        <FieldSpace />
      </div>
    );
  }

  onAddNewVoucherClicked = () => {
    const {vouchers, availableVouchers, redeemedVouchers, newVoucher} = this.state;
    if (newVoucher && newVoucher.trim().length > 0) {
      const newVoucherCopy = {
        id: -(new Date().getMilliseconds()),
        code: newVoucher.trim(),
        quantity: 1,
      };
      vouchers.splice(0, 0, newVoucherCopy);
      availableVouchers.splice(0, 0, newVoucherCopy);
    }
    this.updateState({vouchers, availableVouchers, newVoucher: ''});
  };

  onDeleteAvailableVoucher = (voucher, index) => {
    const {vouchers, availableVouchers, deleteVoucherIds} = this.state;
    if (voucher.id && voucher.id > 0) {
      deleteVoucherIds.push(voucher.id);
    }
    availableVouchers.splice(index, 1);

    let vIndex = -1;
    let count = 0;
    vouchers.forEach((voucherL) => {
      if (voucherL.id === voucher.id) {
        vIndex = count;
      }
      count++;
    });
    if (vIndex >= 0) {
      vouchers.splice(vIndex, 1);
    }
    this.updateState({vouchers, availableVouchers, deleteVoucherIds});
  };

  onDeleteRedeemVoucher = (voucher, index) => {
    const {vouchers, redeemedVouchers, deleteVoucherIds} = this.state;
    if (voucher.id && voucher.id > 0) {
      deleteVoucherIds.push(voucher.id);
    }
    redeemedVouchers.splice(index, 1);

    let vIndex = -1;
    let count = 0;
    vouchers.forEach((voucherL) => {
      if (voucherL.id === voucher.id) {
        vIndex = count;
      }
      count++;
    });
    if (vIndex >= 0) {
      vouchers.splice(vIndex, 1);
    }
    this.updateState({vouchers, redeemedVouchers, deleteVoucherIds});
  };

  onChange = (event) => {
    const value = event.target.value;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageActivityVoucher.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityVoucher.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = () => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityVoucher))
);
